import { Component, inject, signal, computed, effect, ViewChild, HostListener, ElementRef } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { ClientDetailsService } from '../../core/services/client-details.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'app-navbar',
    imports: [MatToolbarModule, MatIconModule, MatButtonModule, MatSidenavModule, MatMenuModule, RouterModule],
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private readonly clientDetailsService = inject(ClientDetailsService);
  private readonly authService = inject(AuthService);
  readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  @ViewChild('drawer') drawer: any;
  
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {

    if (window.innerWidth <= 768) {
      const sidenavElement = this.drawer?._elementRef?.nativeElement;
      const hamburgerBtn = document.querySelector('.navbar-toggler');
 
      if (sidenavElement && this.drawer.opened && 
          !sidenavElement.contains(event.target as Node) && 
          !hamburgerBtn?.contains(event.target as Node)) {
        this.drawer.close();
      }
    }
  }

  // Use the client details service for dynamic logo and company name
  readonly logoUrl = this.clientDetailsService.logoUrl;
  readonly logoCssClass = this.clientDetailsService.logoCssClass;
  readonly logoIsValid = this.clientDetailsService.logoIsValid;
  readonly companyName = this.clientDetailsService.companyName;
  readonly isLoading = this.clientDetailsService.isLoading;
  readonly error = this.clientDetailsService.error;

  constructor() {
    // Log the dynamic values for demonstration
    
    
    // Subscribe to changes
    effect(() => {
     
    });
  }

  onLogoError(): void {
    
  }

  onLogoLoad(): void {
   
  }
  
  // Authentication state
  readonly isLoggedIn = this.authService.isLoggedIn;
  readonly currentUser = this.authService.currentUser;
  
  readonly userDisplayName = computed(() => {
    const user = this.currentUser();
    return user ? `${user.firstName} ${user.lastName}` : '';
  });

  showLoginForm(): void {
    this.authService.showLoginForm();
    
    // Check if we're already on the home page
    if (this.router.url !== '/' && this.router.url !== '/home') {
      // Navigate to home page to show login form
      this.router.navigate(['/']);
    }
  }

  navigateToHome(): void {
    this.authService.hideLoginForm();
    
    // Check if we're already on the home page
    if (this.router.url !== '/' && this.router.url !== '/home') {
      // Navigate to home page
      this.router.navigate(['/']);
    }
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/']);
  }

  navigateToProfile(): void {
    this.router.navigate(['/my-profile']);
  }
} 